
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const PoliticaPrivacidadePage = lazy(() => import('../pages/politica-privacidade/page'));
const PoliticaCookiesPage = lazy(() => import('../pages/politica-cookies/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/politica-privacidade',
    element: <PoliticaPrivacidadePage />,
  },
  {
    path: '/politica-cookies',
    element: <PoliticaCookiesPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
